import { computed } from 'vue';

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
}

export const usePagination = (props: PaginationProps) => {
  const canGoPrevious = computed(() => props.currentPage > 1);
  const canGoNext = computed(() => props.currentPage < props.totalPages);
  const shouldShowPagination = computed(() => props.totalPages > 1);

  return {
    canGoPrevious,
    canGoNext,
    shouldShowPagination,
  };
};

export const useFullPagination = (props: PaginationProps) => {
  const basePagination = usePagination(props);

  const displayPages = computed(() => {
    const pages: (number | string)[] = [];
    const { totalPages, currentPage } = props;

    // Show 2 pages before and 2 pages after current page
    const range = 2;
    const start = Math.max(1, currentPage - range);
    const end = Math.min(totalPages, currentPage + range);

    // Always show first page
    if (start > 1) {
      pages.push(1);
      if (start > 2) {
        pages.push('...');
      }
    }

    // Show current range
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Always show last page
    if (end < totalPages) {
      if (end < totalPages - 1) {
        pages.push('...');
      }
      pages.push(totalPages);
    }

    return pages;
  });

  return {
    ...basePagination,
    displayPages,
  };
};